<template>
    <div class="setting-home">
        <div>
            <div class="info-down-tips"><i class="iconfont icon-mima"></i>登录密码</div>
                <div class="info-down-desc">密码过期时间 {{$store.state.currentUser && ($store.state.currentUser.passwordExpirationTime != null ? '：'+$store.state.currentUser.passwordExpirationTime : '-')}}</div>
                <div class="info-down-status"><i class="iconfont" :class="{'icon-chenggong':!$store.state.overdue,'icon-jinggao2':$store.state.overdue}"></i><span>{{$store.state.overdue ? '已过期' : '未过期'}}<span>|</span><a  @click="link( '/updatePassword' )">修改</a></span></div>
            <!-- <div class="info-down-desc">密码过期时间：2019-12-20 01:56:00（GMT + 8:00）</div>
            <div class="info-down-status" :class="{'info-down-warning': !iconStatus}"><i class="iconfont" :class="{'icon-chenggong':iconStatus,'icon-jinggao2':!iconStatus}"></i><span>未过期<span>|</span><a @click="link( '/updatePassword' )">修改</a></span></div> -->
        </div>
        <!-- <div>
            <div class="info-down-tips"><i class="iconfont icon-shijian"></i>绑定邮箱</div>
            <div class="info-down-desc">您未绑定邮箱</div>
            <div class="info-down-status" :class="{'info-down-warning': iconStatus}"><i class="iconfont" :class="{'icon-chenggong':!iconStatus,'icon-jinggao2':iconStatus}"></i><span>未绑定<span>|</span><a href="#">绑定</a></span></div>
        </div> -->
        <!-- <div>
            <div class="info-down-tips"><i class="iconfont icon-shouji"></i>手机</div>
            <div class="info-down-desc">
                {{$store.state.currentUser != null ? ($store.state.currentUser.mobile != null && $store.state.currentUser.mobile != '' ? $store.state.currentUser.mobile : '您未绑定手机') : '您未绑定手机'}}
            </div>
            <div v-if="$store.state.currentUser == null || $store.state.currentUser.mobile == null || $store.state.currentUser.mobile == ''" class="info-down-status" :class="{'info-down-warning': iconStatus}"><i class="iconfont" :class="{'icon-chenggong':!iconStatus,'icon-jinggao2':iconStatus}"></i><span>未设置<span>|</span><a @click="link( '/bindingCellPhone' )">绑定</a></span></div>
            <div v-else class="info-down-status"><i class="iconfont icon-chenggong"></i><span>已设置<span>|</span><a  @click="link( '/bindingCellPhone' )">修改</a></span></div>
        </div> -->
        <!-- <div>
            <div class="info-down-tips"><i class="iconfont icon-iconzh1"></i>密保问题</div>
            <div class="info-down-desc">您未设置密保问题</div>
            <div class="info-down-status" :class="{'info-down-warning': iconStatus}"><i class="iconfont icon-chenggong"></i><span>未绑定<span>|</span><a @click="link( '/setInsurance' )">查看</a></span></div>
        </div> -->
    </div>
</template>

<script>
export default {
    components: {
        
    },
    computed: {
        userInfo () {
            return this.$store.state.currentUser
        }
    },
    name: 'settingHome',
    data () {
        return {
            iconStatus: true,
        }
    },
    methods : {
        link( route ){
            // var router = this.$store.state.routerData;
            // for( var i in router ){
            //     if( router[i].url.indexOf( route ) > -1 ){
            //         break;
            //     } else if( router[i].url.indexOf( route ) < 0 ){
            //         switch( route ){
            //             case '/updatePassword':
            //                 router.push({ name: '修改登录密码', url: route });
            //             break;
            //             case '/bindingCellPhone':
            //                 router.push({ name: '绑定手机', url: route });
            //             break;
            //             case '/setInsurance':
            //                 router.push({ name: '设置密保', url: route });
            //             break;
            //         }
            //     }
            // }
            // this.$router.push( {path: route} );

            // var routeArr = [];
            // if (route == '/updatePassword') {
            //     routeArr.push({ name: '安全设置', url: '/securitySetting' }, { name: '修改登录密码', url: route });
            // } else if (route == '/bindingCellPhone') {
            //     routeArr.push({ name: '安全设置', url: '/securitySetting' }, { name: '绑定手机', url: route });
            // } else if (route == '/setInsurance') {
            //     routeArr.push({ name: '安全设置', url: '/securitySetting' }, { name: '设置密保', url: route });
            // }
            // this.$store.commit('routerData',Array.from(new Set(routeArr)));
            const smartType = this.userInfo.smartType
            if ( smartType === '0' && route === '/bindingCellPhone') {
                window.open( process.env.HRURL )
            }
            else {
                this.$router.push( {path: route} );
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.setting-home{
    div{
        border-bottom: 1px solid #e8e8e8; height: 80px; line-height: 80px; margin: 0 20px; display: flex; justify-content: space-between; align-items: center;
        .info-down-tips{
            font-size: 14px;
            i{
                color: #77839F; margin-right: 10px; font-size: 18px;
            }
        }
        .info-down-desc{
            font-size: 12px; color: #8391AF; min-width: 360px; margin-left: -170px;
        }
        .info-down-status{
            font-size: 12px; margin-right: 80px; color: #75B035; min-width: 111px; text-align: right; display: flex; align-items: baseline; justify-content: flex-end;
            span{
                margin: 0 8px;
                span{
                    color: #d8d8d8;
                }
                a{
                    color: #148EF5; text-decoration: none; cursor: pointer;
                }
            }
            i{
                font-size: 16px;
            }
        }
        .info-down-warning{
            color: #FAA51F;
        }
        .icon-jinggao2 {
            color: #FAA51F;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/settingHome.vue